// @ vendors
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ actions
const notification = require('actions/notifications');

// @ constants
const actionTypes = require('constants/actionTypes');

const { BROKER_CUSTOM_WALLET_PG_VIEW } = require('../constants/index');

const changeDefault = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_REQUEST,
});

const cancelChangeDefault = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CANCELED,
});

const changeDefaultCheckboxChanged = (defaultViewId) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CHECKBOX_CHANGED,
    payload: {
        data: defaultViewId,
    }
});

const confirmedChangeDefaultSuccess = (idDefaultViewToSet) => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CONFIRMED_SUCCESS,
    payload: {
        idDefaultViewToSet
    }
});

const confirmedChangeDefaultFail = () => ({
    type: actionTypes.BROKER_CUSTOM_WALLET_CHANGE_DEFAULT_CONFIRMED_FAIL,
});

const outdateMyInvestments = () => (dispatch) => {
    return dispatch({
        type: actionTypes.CW_GET_MY_INVESTMENTS_SET_OUTDATED
    });
};

const confirmedChangeDefault = (idDefaultViewToSet) => (dispatch) => {
    const url = apiURLBuilder.getURL('brokerSetDefaultView');

    const requestData = {
        query : {
            preferences: [
                {
                    name: BROKER_CUSTOM_WALLET_PG_VIEW,
                    value: idDefaultViewToSet
                }
            ]
        }
    }
    let message;
    return APIPost(dispatch, url, requestData)
        .then(function() {
                message = formatText('brokerCustomWallet-changeDefaultViewSuccess');
                dispatch(notification.success({message}, {voice: message}));
                dispatch (confirmedChangeDefaultSuccess(idDefaultViewToSet));
                dispatch (outdateMyInvestments());
            }, function() {
                message = formatText('brokerCustomWallet-changeDefaultViewError');
                dispatch(notification.error({message}, {voice: message}));
                dispatch (confirmedChangeDefaultFail());
            }
        );
};

module.exports = {    
    changeDefault,
    cancelChangeDefault,
    changeDefaultCheckboxChanged,
    confirmedChangeDefault,
    outdateMyInvestments
}
